<template>
  <span>
    <v-icon small>train</v-icon>
    {{ vehicle.name }}
  </span>
</template>

<script>
export default {
  props: {
    vehicle: Object,
  }
};
</script>
